import { ClerkProvider } from "@clerk/clerk-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/instrument-sans";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import { App } from "./App";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

// T2 mobile inbox PWA: a plain SW registration makes /inbox installable;
// T3 extends the worker with push. Never blocks rendering.
if (!import.meta.env.DEV && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}

const isInbox = window.location.pathname.startsWith("/inbox");

if (
  import.meta.env.DEV &&
  window.location.pathname === "/__workspace-fixture"
) {
  void import("./dev/EditorFixture").then(({ WorkspaceFixtureApp }) => {
    createRoot(root).render(
      <StrictMode>
        <WorkspaceFixtureApp />
      </StrictMode>,
    );
  });
} else if (
  import.meta.env.DEV &&
  window.location.pathname === "/__editor-fixture"
) {
  void import("./dev/EditorFixture").then(({ EditorFixtureApp }) => {
    createRoot(root).render(
      <StrictMode>
        <EditorFixtureApp />
      </StrictMode>,
    );
  });
} else {
  const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
  if (!publishableKey) {
    throw new Error("VITE_CLERK_PUBLISHABLE_KEY is not set");
  }

  createRoot(root).render(
    <StrictMode>
      <ClerkProvider
        publishableKey={publishableKey}
        afterSignOutUrl="/"
        signInFallbackRedirectUrl="/"
        signInForceRedirectUrl="/"
        signUpFallbackRedirectUrl="/"
        signUpForceRedirectUrl="/"
        taskUrls={{ "choose-organization": "/" }}
      >
        <App view={isInbox ? "inbox" : "dashboard"} />
      </ClerkProvider>
    </StrictMode>,
  );
}
